import React, { Suspense, lazy, useCallback, useState } from "react";

// The wizard is a lazy chunk: the cards, menu and pCard that offer
// "Send Forms" only gain this file.
const SendFormsWizard = lazy(() => import("./SendFormsWizard"));

// A dashboard / chart / pCard row -> the wizard's patient prop.
export function patientFromRow(row, dob) {
  if (!row || !row.patientid) return null;
  const name = [row.firstname, row.lastname].filter(Boolean).join(" ").trim()
    || row.patientname || row.fullname || row.patientinfo || "";
  return {
    patientid: row.patientid,
    name,
    dob: dob || row.dob || "",
    phone: row.mobilephone || row.phone || "",
    email: row.email || "",
  };
}

/*
 * const [openSendForms, sendFormsWizard] = useSendFormsWizard();
 *   openSendForms(row, {dob?, onSent?})  opens the wizard for that patient
 *                                         (row.appointmentid = the visit)
 *   {sendFormsWizard}                     render it anywhere in the caller
 */
export function useSendFormsWizard() {
  const [target, setTarget] = useState(null);
  const open = useCallback((row, opts = {}) => {
    const patient = patientFromRow(row, opts.dob);
    setTarget({ patient, appointmentid: (row && row.appointmentid) || null, onSent: opts.onSent || null });
  }, []);
  const element = target ? (
    <Suspense fallback={null}>
      <SendFormsWizard
        open
        patient={target.patient}
        appointmentid={target.appointmentid}
        onClose={(res) => {
          const cb = target.onSent;
          setTarget(null);
          if (cb && res && res.sent) cb(res);
        }}
      />
    </Suspense>
  ) : null;
  return [open, element];
}

export default useSendFormsWizard;
